import { GET } from "../utils/crud"

const getTicket = async (id) => {
	const response = await GET(`tickets/${id}`)
	return response
}

export default {
	getTicket,
}
